/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { LegalEntityProps } from '../../types';

import { LegalEntityFormAction } from './constants';
import { StateType, ActionType } from './types';

export const initialState: StateType = {
  legalEntity: {} as LegalEntityProps,
  loadingLegalEntity: false,
};

const reducer: Reducer<StateType, ActionType> = produce(
  (draft: Draft<StateType>, action: ActionType) => {
    const { type } = action;
    switch (type) {
      case LegalEntityFormAction.SET_LEGAL_ENTITY: {
        if (!('legalEntity' in action)) throw new Error('legalEntity is missing');
        draft.legalEntity = action.legalEntity;
        break;
      }
      case LegalEntityFormAction.CREATE_LEGAL_ENTITY: {
        if (!('legalEntity' in action)) throw new Error('legalEntity is missing');
        draft.legalEntity = { ...draft.legalEntity, ...action.legalEntity };
        break;
      }
      case LegalEntityFormAction.UPDATE_LEGAL_ENTITY: {
        if (!('legalEntity' in action)) throw new Error('legalEntity is missing');
        draft.legalEntity = { ...draft.legalEntity, ...action.legalEntity };
        break;
      }
      case LegalEntityFormAction.SET_LOADING_LEGAL_ENTITY: {
        const { loading } = action;
        draft.loadingLegalEntity = loading;
        break;
      }
      default:
        throw new Error('Unexpected object');
    }
  },
  initialState
);

export const useLegalEntityFormReducer = (): [StateType, Dispatch<ActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
